import React, {useContext, useRef, useState} from 'react';
import {useNavigate} from 'react-router';
import {LOGIN_ROUTE, VEHICLES_ROUTE} from '../../util/constants';
import {ActivateHandle} from '../../util/interfaces';
import {logout} from '../../util/requestSender';
import {createErrorMessage} from '../../util/utils';
import {AppContext} from '../context/appContext';
import ExportController from '../export/exportController';
import Menu from './menu';
import {ResponseData, showDialog, showSnackbar} from '@dvrd/dvr-controls';

export default function MenuController() {
    const {onChangeContext} = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const exportRef = useRef<ActivateHandle>(null);

    function onClickLogout() {
        setLoading(true);
        logout({
            callback: (data: ResponseData) => {
                if (data.success) {
                    onChangeContext({user: null, vehicles: [], vehicle: null}, () => {
                        navigate(LOGIN_ROUTE);
                    });
                    showSnackbar('Je bent uitgelogd');
                } else
                    showDialog(createErrorMessage(data.message ?? 'Het uitloggen is niet gelukt.'),
                        'Uitloggen mislukt');
            }
        });
    }

    function onClickDownload() {
        exportRef.current?.activate();
    }

    function onClickVehicles() {
        navigate(VEHICLES_ROUTE);
    }

    return (
        <>
            <Menu onClickLogout={onClickLogout} onClickDownload={onClickDownload} onClickVehicles={onClickVehicles}
                  loading={loading}/>
            <ExportController ref={exportRef}/>
        </>
    );
}

MenuController.displayName = 'MenuController';